import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AutoWithdrawalTierDTO, BinRangeExclusionDTO } from '../auto-withdrawals-config.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoWithdrawalsConfigComponent } from '../auto-withdrawals-config.component';
import { AutoWithdrawalsConfigService } from '../auto-withdrawals-config.service';
import { CurrencyService } from '../../../../../common/services/currency.service';
import { FieldConfigDTO } from '../../../../../system/system-dtos';
import { DataType } from '../../../../data-type-widgets/data-type/data-type-component';

@Component({
  selector: 'app-bin-range-exclusion',
  templateUrl: './bin-range-exclusion.component.html',
  styleUrls: ['./bin-range-exclusion.component.scss'],
  standalone: false,
})
export class BinRangeExclusionComponent implements OnInit {
  formGroup: UntypedFormGroup;

  binRangeExclusion: BinRangeExclusionDTO;

  paymentSolutionsList: string[] = ['ADYEN', 'WORLDPAY'];

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AutoWithdrawalsConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { binRangeExclusionId: number },
    private service: AutoWithdrawalsConfigService
  ) {}

  ngOnInit(): void {
    if (this.data?.binRangeExclusionId) {
      this.service.getBinRangeExclusion(this.data?.binRangeExclusionId).subscribe((e) => {
        this.binRangeExclusion = e;
        this.buildForm();
      });
    } else {
      this.buildForm();
    }
  }

  private buildForm(): void {
    this.formGroup = this.fb.group({
      id: [this.binRangeExclusion?.id || null],
      paymentSolutions: [this.binRangeExclusion?.paymentSolutions || null, Validators.required],
      binRange: [
        this.binRangeExclusion?.binRange || null,
        Validators.compose([Validators.required, Validators.min(1), Validators.max(999999)]),
      ],
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    const formValue = this.formGroup.value;
    if (this.data?.binRangeExclusionId) {
      this.service.updateBinRangeExclusion(this.data?.binRangeExclusionId, formValue).subscribe(() => {
        this.dialogRef.close(true);
      });
    } else {
      this.service.insertBinRangeExclusion(formValue).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }
}
